import { LANGUAGE_EN } from '../../util/translation.helpers'

const brandConfig = {
  brandId: 'qbx_vip',
  name: 'QBX VIP Club',
  description:
    'The most rewarding Web3 loyalty program. Stake your QBX, earn VIR points, and get epic products, crypto, and miles!',
  appUrl: 'https://vip.qiibeefoundation.org/',
  appIcon: 'http://vip.qiibeefoundation.org/assets/icons/qbx-vip-club.png',
  supportEmail: 'support-qbxvipclub@qiibee.com',
  faqUrl:
    'https://qiibee.notion.site/QBX-VIP-CLUB-FAQ-1a07a68e7e1d80bca29ff3c4a066b0a6',
  helpCenterUrl:
    'https://qiibee.notion.site/qbx-vip-club-help-center?v=1a07a68e7e1d814f851e000ccc436f66&pvs=4',
  websiteUrl: 'https://qiibeefoundation.org/qbx-vip-club/',
  termsUrl:
    'https://qiibee.notion.site/Terms-and-Conditions-1ab7a68e7e1d803a84d2c3d3d6f5bfe5',
  privacyPolicyUrl:
    'https://qiibee.notion.site/Privacy-Policy-1ac7a68e7e1d8001865bcb9d22f26d12',
  cookiePolicyUrl:
    'https://qiibee.notion.site/Cookie-Policy-1ac7a68e7e1d808b9cdffa8274db9219',
  supportedLanguages: [LANGUAGE_EN],
  theme: {
    lighter: '#FEF4D4',
    light: '#FED680',
    mid: '#fed680',
    main: '#fda92d',
    dark: '#B66816',
    darker: '#793908',
    contrastText: '#1C252E'
  },
  features: {
    enableImpactReport: true,
    enableRootImpactReport: true,
    homeBanners: true,
    enableCOEStorefront: true,
    staking: true,
    rewardBoxes: true,
    membership: true
  },
  cognito: {
    region: 'eu-central-1',
    poolId: 'eu-central-1_6bu4ynztS',
    clientId: 'f5j7n0vp8lsblqltvjkhor832',
    poolDomain: 'qbxvip.auth.eu-central-1.amazoncognito.com',
    redirectUri: 'https://vip.qiibeefoundation.org/login'
  },
  prodegeToken: 'ffb5b471-7b8a-4ff5-b6d1-c0d0e3fb95e1',
  gaTrackingId: '',
  hotjarId: '3125123',
  googleTagManagerId: 'GTM-THCMT76H',
  loyalizePid: '7557207',
  eventsUrl: 'https://tickets.qiibeefoundation.org/'
}

export default brandConfig
